import { SanityProductCategoryName } from '@gelato-api-ui/core/sanity/sanity-product-category-name.enum';
import { ApparelAndAccessoriesSanityProductCategoryNames } from '@gelato-api-ui/core/sanity/apparel-and-accessories-sanity-product-category-names';

export const getDefaultPrimaryPreviewSceneByProductCategory = (productCategoryName: string): string =>
  ApparelAndAccessoriesSanityProductCategoryNames.includes(productCategoryName as SanityProductCategoryName)
    ? 'editor/front'
    : null;
